import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    //#region properties

    //#region private
    private _activeRequest: number = 0;
    private _loaderVisible: boolean = false;
    //#endregion

    //#endregion

    //#region setters
    public set loaderVisible(value: boolean) {
        this._loaderVisible = value;
    }
    //#endregion

    //#region getters
    public get loaderVisible() {
        return this._loaderVisible;
    }
    //#endregion

    //#region ctor
    //#endregion

    //#region private actions
    //#endregion

    //#region public actions
    public showLoader() {
        this._activeRequest++;
        this._loaderVisible = true;
    }

    public hideLoader() {
        this._activeRequest--;
        if(this._activeRequest <= 0) {
            this._activeRequest = 0;
            this._loaderVisible = false;
        } else {
        }
    }

    public forceHideLoader() {
        this._activeRequest = 0;
        this._loaderVisible = false;
    }
    //#endregion
}